import { patchAutoComplete } from './autocomplete'
import { patchAutoFocus } from './autofocus'
import { patchConnectedOverlayScroll } from './connected-overlay-scroll'
import { patchDialogFocus } from './dialog-focus'
import { patchMenu } from './menu'
import { patchMultiSelect } from './multiselect'
import { patchOverlay } from './overlay'
import { patchPopover } from './popover'
import { patchSelect } from './select'
import { patchTieredMenu } from './tiered-menu'

export function applyPrimeNgOverrides() {
  patchAutoComplete()
  patchAutoFocus()
  patchConnectedOverlayScroll()
  patchDialogFocus()
  patchMenu()
  patchMultiSelect()
  patchOverlay()
  patchPopover()
  patchSelect()
  patchTieredMenu()
}
